import React from 'react';
import { motion } from 'framer-motion';
import { colors } from '../colors';

const Project = ({ title, description, technologies, link, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay: index * 0.1 }}
    className="mb-8 p-6 bg-gray-800 rounded-lg shadow-lg"
  >
    <h3 className="text-2xl font-bold mb-2" style={{ color: colors.primary }}>{title}</h3>
    <p className="mb-4">{description}</p>
    {technologies && technologies.length > 0 && (
      <p className="mb-2">
        <span className="font-bold">Technologies:</span> {technologies.join(', ')}
      </p>
    )}
    {link && (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-400 hover:underline"
      >
        View Project
      </a>
    )}
  </motion.div>
);

export default Project;
